import _slicedToArray from "/Users/n8/Development/EtherGrass V2/code/.build/websites/ethergrass.io/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useReducer } from 'react';
import { useDebouncePair, useEthers } from '../../hooks';
import { useBlockNumber } from '../blockNumber/context';
import { ChainStateContext } from './context';
import { chainStateReducer } from './chainStateReducer';
import { callsReducer } from './callsReducer';
import { multicall } from './multicall';
import { notifyDevtools } from '../devtools';
import { useDevtoolsReporting } from './useDevtoolsReporting';
export function ChainStateProvider(_ref) {
  var children = _ref.children,
      multicallAddresses = _ref.multicallAddresses;

  var _useEthers = useEthers(),
      library = _useEthers.library,
      chainId = _useEthers.chainId;

  var blockNumber = useBlockNumber();

  var _useReducer = useReducer(callsReducer, []),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      calls = _useReducer2[0],
      dispatchCalls = _useReducer2[1];

  var _useReducer3 = useReducer(chainStateReducer, {}),
      _useReducer4 = _slicedToArray(_useReducer3, 2),
      state = _useReducer4[0],
      dispatchState = _useReducer4[1];

  var _useDebouncePair = useDebouncePair(calls, chainId, 50),
      _useDebouncePair2 = _slicedToArray(_useDebouncePair, 2),
      debouncedCalls = _useDebouncePair2[0],
      debouncedId = _useDebouncePair2[1];

  var uniqueCalls = debouncedId === chainId ? getUnique(debouncedCalls) : []; // used for deep equality in hook dependencies

  var uniqueCallsJSON = JSON.stringify(uniqueCalls);
  var multicallAddress = chainId !== undefined ? multicallAddresses[chainId] : undefined;
  useDevtoolsReporting(uniqueCallsJSON, uniqueCalls, blockNumber, multicallAddresses);
  useEffect(function () {
    if (library && blockNumber !== undefined && chainId !== undefined) {
      if (!multicallAddress) {
        console.error("Missing multicall address for chain id ".concat(chainId));
        return;
      }

      var start = Date.now();
      multicall(library, multicallAddress, blockNumber, uniqueCalls).then(function (state) {
        dispatchState({
          type: 'FETCH_SUCCESS',
          blockNumber: blockNumber,
          chainId: chainId,
          state: state
        });
        notifyDevtools({
          type: 'MULTICALL_SUCCESS',
          duration: Date.now() - start,
          chainId: chainId,
          blockNumber: blockNumber,
          multicallAddress: multicallAddress,
          state: state
        });
      }).catch(function (error) {
        console.error(error);
        dispatchState({
          type: 'FETCH_ERROR',
          blockNumber: blockNumber,
          chainId: chainId,
          error: error
        });
        notifyDevtools({
          type: 'MULTICALL_ERROR',
          duration: Date.now() - start,
          chainId: chainId,
          blockNumber: blockNumber,
          multicallAddress: multicallAddress,
          calls: uniqueCalls,
          error: error
        });
      });
    }
  }, [library, blockNumber, chainId, multicallAddress, uniqueCallsJSON]);
  var value = chainId !== undefined ? state[chainId] : undefined;
  var provided = {
    value: value,
    multicallAddress: multicallAddress,
    dispatchCalls: dispatchCalls
  };
  return _jsx(ChainStateContext.Provider, {
    value: provided,
    children: children
  }, void 0);
}

function getUnique(requests) {
  var unique = [];

  var _iterator = _createForOfIteratorHelper(requests),
      _step;

  try {
    var _loop = function _loop() {
      var request = _step.value;

      if (!unique.find(function (x) {
        return x.address === request.address && x.data === request.data;
      })) {
        unique.push(request);
      }
    };

    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return unique;
}